var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArriving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 0.5L0.5 2.125M11.3333 2.125L9.70833 0.5M2.66667 9.16667L1.58333 10.25M9.16667 9.16667L10.25 10.25M5.91667 3.75V5.91667L7 7M5.91667 10.25C7.06592 10.25 8.16816 9.79343 8.98082 8.98082C9.79343 8.16816 10.25 7.06592 10.25 5.91667C10.25 4.76741 9.79343 3.6652 8.98082 2.85254C8.16816 2.03988 7.06592 1.58333 5.91667 1.58333C4.7674 1.58333 3.6652 2.03988 2.85254 2.85254C2.03988 3.6652 1.58333 4.76741 1.58333 5.91667C1.58333 7.06592 2.03988 8.16816 2.85254 8.98082C3.6652 9.79343 4.7674 10.25 5.91667 10.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArriving);
export default __webpack_public_path__ + "static/media/arriving.f471dfefb323fc110a3222fd7df91e95.svg";
export { ForwardRef as ReactComponent };